import { useEffect, useRef, useState } from "react";
import { ZoomIn, ZoomOut, RotateCw, Maximize2 } from "lucide-react";

export default function ZoomViewer({ src, className = "", testid = "zoom-viewer" }) {
  const [s, setS] = useState(1);
  const [r, setR] = useState(0);
  const [o, setO] = useState({ x: 0, y: 0 });
  const drag = useRef(null);
  useEffect(() => { setS(1); setR(0); setO({ x: 0, y: 0 }); }, [src]);
  const zoom = (d) => setS((v) => Math.min(8, Math.max(0.5, +(v + d).toFixed(2))));
  const btn = "w-9 h-9 rounded-full bg-white/90 hover:bg-white text-slate-800 flex items-center justify-center shadow";

  return (
    <div className={`relative overflow-hidden bg-slate-900 select-none touch-none ${className}`} data-testid={testid}
      onWheel={(e) => zoom(e.deltaY < 0 ? 0.25 : -0.25)} onDoubleClick={() => setS((v) => (v > 1 ? 1 : 2.5))}
      onPointerDown={(e) => { drag.current = { x: e.clientX - o.x, y: e.clientY - o.y }; e.currentTarget.setPointerCapture(e.pointerId); }}
      onPointerMove={(e) => { if (drag.current) setO({ x: e.clientX - drag.current.x, y: e.clientY - drag.current.y }); }}
      onPointerUp={() => { drag.current = null; }}>
      <img src={src} alt="Bill" draggable={false} className="absolute inset-0 m-auto max-w-full max-h-full cursor-grab active:cursor-grabbing"
        style={{ transform: `translate(${o.x}px, ${o.y}px) scale(${s}) rotate(${r}deg)`, transition: drag.current ? "none" : "transform 120ms ease-out" }} />
      <div className="absolute bottom-3 left-1/2 -translate-x-1/2 flex items-center gap-2 bg-black/40 backdrop-blur-md rounded-full px-2 py-1.5" onPointerDown={(e) => e.stopPropagation()}>
        <button type="button" className={btn} onClick={() => zoom(-0.5)} data-testid={`${testid}-zoom-out`}><ZoomOut className="w-4 h-4" /></button>
        <span className="num text-xs text-white w-12 text-center" data-testid={`${testid}-level`}>{Math.round(s * 100)}%</span>
        <button type="button" className={btn} onClick={() => zoom(0.5)} data-testid={`${testid}-zoom-in`}><ZoomIn className="w-4 h-4" /></button>
        <button type="button" className={btn} onClick={() => setR((v) => (v + 90) % 360)} data-testid={`${testid}-rotate`}><RotateCw className="w-4 h-4" /></button>
        <button type="button" className={btn} onClick={() => { setS(1); setR(0); setO({ x: 0, y: 0 }); }} data-testid={`${testid}-reset`}><Maximize2 className="w-4 h-4" /></button>
      </div>
    </div>
  );
}
